module.exports = __webpack_public_path__ + "assets/images/circle-right-chevron.a66ee03cbf5551f91024cd75751e6460.svg";